import operationsEscl from '../locales/es-CL/operations.json';
import operationsEsmx from '../locales/es-MX/operations.json';
import operationsEsco from '../locales/es-CO/operations.json';
import operationsEnus from '../locales/en-US/operations.json';
import DriverService from '../services/DriverService';
import VehicleService from '../services/VehicleService';
import showAlert from '../alert/alertHandler';
import showOperationDetail from '../operationDetail/operationDetailHandler';

import Multiselect from 'vue-multiselect';
import Container from 'typedi';
import moment from 'moment';
import axios from 'axios';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

export default {
  name: 'Operations',
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  i18n: {
    messages: {
      'es-CL': {
        operations: operationsEscl,
      },
      'es-MX': {
        operations: operationsEsmx,
      },
      'es-CO': {
        operations: operationsEsco,
      },
      'en-US': {
        operations: operationsEnus,
      },
    },
  },
  data() {
    return {
      driverService: null,
      vehicleService: null,
      dataAccess: null,
      isMainPageBussy: false,
      showFilters: false,
      isFilterClicked: false,
      isFilterApplied: false,
      filter: null,
      vehicles: [],
      drivers: [],
      operations: [],
      operationsMap: [],
      actualDateZone: {
        start: null,
        end: null,
      },
      filterOperation: {
        date: null,
        until: null,
        nameOperation: null,
        idRoute: null,
        vehicles: [],
        drivers: [],
        state: [],
        type: null,
      },
      totalOperationsPending: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      states: [
        { id: 'DONE', name: 'Successful' },
        { id: 'PARTIALLYDONE', name: 'Partially Done' },
        { id: 'REJECTED', name: 'Fail' },
        { id: 'NOTDONE', name: 'Not done' },
        //{ id: 'CANCELED', name: 'Canceled' },
      ],
      badges: {
        NOTDONE: {
          background: 'FFFFFF',
          color: '#03475E',
          border: '2px solid #03475E',
        },
        DONE: {
          background: 'FFFFFF',
          color: '#52A145',
          border: '2px solid #52A145',
        },
        REJECTED: {
          background: 'FFFFFF',
          color: '#e62121',
          border: '2px solid #e62121',
        },
        CANCELED: {
          background: 'FFFFFF',
          color: '#C21F25',
          border: '2px solid #C21F25',
        },
        PARTIALLYDONE: {
          background: 'FFFFFF',
          color: '#eeb71f',
          border: '2px solid #eeb71f',
        },
      },
      operationTypeOptions: [
        {
          type: 'DELIVERY',
          name: 'Entrega',
        },
        {
          type: 'COLLECTION',
          name: 'Retiro',
        },
      ],
      refreshCountDown: 0,
      refreshCountDownStart: 10,
      filterText: null,
      filterTextHandled: null,
      suggestions: [],
      filteredSuggestions: {
        operationName: [],
        operationType: [],
        operationState: [],
        driver: [],
        vehicle: [],
        address: [],
        scheduled: [],
      },
      validDate: true,
      globalStats: {
        totalOps: 0,
        totalOpsDone: 0,
        totalOpsPending: 0,
        totalOpsRejected: 0,
        totalOpsPartially: 0,
        totalOpsFilter: 0,
        totalOpsDoneFilter: 0,
        totalOpsPendingFilter: 0,
        totalOpsRejectedFilter: 0,
        totalOpsPartiallyFilter: 0,
      },
      tags: [],
    };
  },
  async created() {
    this.driverService = Container.get(DriverService);
    this.vehicleService = Container.get(VehicleService);
    await this.prepareData();
  },
  methods: {
    async prepareData() {
      this.isMainPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      this.actualDateZone.start =  moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD');
      this.actualDateZone.end = moment().endOf('day').format('YYYY-MM-DD');
      this.operations = await this.getOperations();
      this.isMainPageBussy = false;
      this.getDrivers();
      this.getVehicles();
    },
    /* metodos de carga de datos complementarios */
    async getDrivers() {
      const includeOnlyUsers = false;
      const drivers = await this.driverService.getDrivers(includeOnlyUsers);
      this.drivers = drivers;
      this.drivers.forEach((driver) => {
        driver.fullName = this.transformWords(driver.firstName) + ' ' + this.transformWords(driver.lastName);
      });
    },
    async getVehicles() {
      const vehicles = await this.vehicleService.getVehicles();
      this.vehicles = vehicles;
    },
    prepareFilters() {
      let filters = '';
      if (this.actualDateZone.end) {
        const dateStamp = new Date(this.actualDateZone.end + ' 23:59:59').getTime();
        filters = filters.concat('&createdToDate=', dateStamp);
      }
      if (this.filterOperation.name) {
        filters = filters.concat('&name=', this.filterOperation.name);
      }
      if (this.filterOperation.idRoute) {
        filters = filters.concat('&idRoute=', this.filterOperation.idRoute);
      }
      if (this.filterOperation.state && this.filterOperation.state.length > 0) {
        this.filterOperation.state.forEach((state) => {
          filters = filters.concat('&state=', state.id);
        });
      }else{
        filters = filters.concat(`&state=NOTDONE&state=DONE&state=REJECTED&state=PARTIALLYDONE`);
      }
      if (this.filterOperation.vehicles && this.filterOperation.vehicles.length > 0) {
        this.filterOperation.vehicles.forEach((vehicle) => {
          filters = filters.concat('&idVehicle=', vehicle.id);
        });
      }
      if (this.filterOperation.drivers && this.filterOperation.drivers.length > 0) {
        this.filterOperation.drivers.forEach((driver) => {
          filters = filters.concat('&idDriver=', driver.id);
        });
      }
      if (this.filterOperation.type) {
        filters = filters.concat('&type=', this.filterOperation.type.type);
      }
      if (this.filterText) {
        filters = filters.concat('&name=', this.filterText);
        this.currentPage = 1;
      }
      return filters;
    },
    async getOperations() {
      const dateStamp = new Date(this.actualDateZone.start + ' 00:00:00').getTime();
      let url = `${this.$store.getters.urlAPI}/operation?pageNum=${this.currentPage}&pageSize=${this.perPage}&createdFromDate=${dateStamp}&excludeDepot=true&includeLocation=true`;
      let urlWithFilters = url.concat(this.prepareFilters());

      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(urlWithFilters, config);
        this.totalOperationsPending = response.data.paginator ? response.data.paginator.totalRows : 0;
        const estadoPrioridad = {
          ONGOING: 1,
          REJECTED: 2,
          PARTIALLYDONE: 3,
          NOTDONE: 4,
          DONE: 5,
        };
        response.data.data.sort((a, b) => {
          // Ordenar por fecha descendente (más reciente primero)
          const fechaA = new Date(a.relationDone ? a.relationDone.startOperationDate : a.relation.startOperationDate);
          const fechaB = new Date(b.relationDone ? b.relationDone.startOperationDate : b.relation.startOperationDate);
          if (fechaA < fechaB) return 1;
          if (fechaA > fechaB) return -1;
        
          // Si la fecha es igual, ordenar por nombre (A-Z)
          const nombreA = a.name.toLowerCase();
          const nombreB = b.name.toLowerCase();
          if (nombreA < nombreB) return -1;
          if (nombreA > nombreB) return 1;
        
          // Si el nombre es igual, ordenar por estado según prioridad
          const prioridadA = estadoPrioridad[a.relation.idState] || 99;
          const prioridadB = estadoPrioridad[b.relation.idState] || 99;
          return prioridadA - prioridadB;
        });
        return response.data.data;
      } catch (e) {
        if (e.response.data.message == 'No encontrado') {
          this.totalOperationsPending = 0;
          return [];
        }
      }
    },
    async handlePageSizeChange() {
      this.currentPage = 1;
      this.isMainPageBussy = true;
      this.operations = await this.getOperations();
      this.isMainPageBussy = false;
    },
    async handlePageChange() {
      this.isMainPageBussy = true;
      this.operations = await this.getOperations();
      this.isMainPageBussy = false;
    },
    async cleanFilter() {      
      this.filterOperation = {
        date: null,
        until: null,
        nameOperation: null,
        idRoute: null,
        vehicles: [],
        drivers: [],
        state: [],
        type: null,
      };
      this.actualDateZone.start =  moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD');
      this.actualDateZone.end = moment().endOf('day').format('YYYY-MM-DD');
      this.isMainPageBussy = true;
      this.operations = await this.getOperations();
      this.isMainPageBussy = false;
    },
    async getRoutesFilterDate() {
      this.validDate = true;
      this.isFilterApplied = true;
      this.isMainPageBussy = true;
      if (this.actualDateZone == null || this.actualDateZone.start == null || this.actualDateZone.end == null) {
        this.validDate = false;
        showAlert('Error', 'Debes especificar un rango horario.');
      } else {  
        this.operations = await this.getOperations();
      }
      this.isMainPageBussy = false;
    },
    transformIdState(state) {
      return state ? this.$t(`operations.statesOperation.${state}`) : this.$t(`operations.statesOperation.NOTDONE`);
    },
    closeModal(id) {
      this.emptyData();
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    activeFilter() {
      this.showFilters = !this.showFilters;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.showFilters && !this.isFilterClicked) {
        this.showFilters = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    limitText(count) {
      return this.$t('operations.limitText') + (count + 1);
    },
    startCountDownTimer() {
      this.refreshCountDown = this.refreshCountDownStart;
      this.getRoutesFilterDate();
      this.autoRefreshTimer = 0;
      this.countDownTimer();
    },
    /**@author Jorge Pizarro Tapia
     * Contador que mantiene deshabilitado en boton de refresco de rutas forzado.
     */
    countDownTimer() {
      if (this.refreshCountDown > 0) {
        this.countDownId = setTimeout(() => {
          this.refreshCountDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    handleSuggestionClick(suggestion) {
      this.filterText = suggestion;
      this.filteredSuggestions = {
        operationName: [],
        operationType: [],
        operationState: [],
        driver: [],
        vehicle: [],
        address: [],
        scheduled: [],
      };
      this.suggestions = [];
    },
    handleInput() {
      this.suggestions = this.filterSuggestions(this.filterText);
      this.filteredSuggestions = {
        operationName: [...new Set(this.suggestions.filter(item => item.type === 'operationName').map(item => item.value))],
        operationType: [...new Set(this.suggestions.filter(item => item.type === 'operationType').map(item => item.value))],
        operationState: [...new Set(this.suggestions.filter(item => item.type === 'operationState').map(item => item.value))],
        driver: [...new Set(this.suggestions.filter(item => item.type === 'driver').map(item => item.value))],
        vehicle: [...new Set(this.suggestions.filter(item => item.type === 'vehicle').map(item => item.value))],
        address: [...new Set(this.suggestions.filter(item => item.type === 'address').map(item => item.value))],
        scheduled: [...new Set(this.suggestions.filter(item => item.type === 'scheduled').map(item => item.value))],
      };
    },
    filterSuggestions(query) {
      if (!query) return [];
      const lowerQuery = query.toLowerCase();
      return this.operationsMap.reduce((acc, item) => {
        if (item.name.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'operationName', value: item.name });
        }
        /* if (item.typeName.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'operationType', value: item.typeName });
        }
        if (item.stateName.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'operationState', value: item.stateName });
        }
        if (item.driver.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'driver', value: item.driver });
        }
        if (item.vehicle.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'vehicle', value: item.vehicle });
        }
        if (item.addressName.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'address', value: item.addressName });
        }
        if (item.scheduled.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'scheduled', value: item.scheduled });
        } */
        return acc;
      }, []);
    },
    cleanFilterText(){
      this.filterText = "";
      this.filterTextHandled = "";
      this.filteredSuggestions = {
        operationName: [],
        operationType: [],
        operationState: [],
        driver: [],
        vehicle: [],
        address: [],
        scheduled: [],
      };
      this.suggestions = [];
      this.handlePageChange();
    },
    obtainPercentage(numOps) {
      if (numOps !== undefined && numOps > 0) {
        const percentage = (numOps / this.globalStats.totalOpsFilter) * 100;
        if (percentage < 1) {
          return percentage.toFixed(1);
        } else {
          return Math.round(percentage);
        }
      }
      return 0;
    },
    resetGlobalStats() {
      this.globalStats= {
        totalOps: 0,
        totalOpsDone: 0,
        totalOpsPending: 0,
        totalOpsRejected: 0,
        totalOpsPartially: 0,
        totalOpsFilter: 0,
        totalOpsDoneFilter: 0,
        totalOpsPendingFilter: 0,
        totalOpsRejectedFilter: 0,
        totalOpsPartiallyFilter: 0,
      };
    },
    openOperationDetailModal(operation) {
      showOperationDetail(operation);
    },
    isResizeRequired() {
      let mayorValue = 0;
      if (this.globalStats.totalOpsFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsFilter;
      }
      if (this.globalStats.totalOpsDoneFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsDoneFilter;
      }
      if (this.globalStats.totalOpsPendingFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsPendingFilter;
      }
      if (this.globalStats.totalOpsRejectedFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsRejectedFilter;
      }
      if (this.globalStats.totalOpsPartiallyFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsPartiallyFilter;
      }
      return Math.floor(Math.abs(mayorValue)).toString().length > 2;
    },
  },
  computed: {
    shortCuts() {
      return [
        { key: 'thisWeek', label: this.$t(`operations.shortcuts.thisWeek`), value: 'isoWeek' },
        { key: 'lastWeek', label: this.$t(`operations.shortcuts.lastWeek`), value: '-isoWeek' },
        { key: 'last7Days', label: this.$t(`operations.shortcuts.last7Days`), value: 6 },
        { key: 'last14Days', label: this.$t(`operations.shortcuts.last14Days`), value: 13 },
        { key: 'last30Days', label: this.$t(`operations.shortcuts.last30Days`), value: 30 },
        { key: 'thisMonth', label: this.$t(`operations.shortcuts.thisMonth`), value: 'month' },
      ];
    },
    operationFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        /* {
          key: 'planificationName',
          label: this.$t('operations.table.planificationName'),
          ...common,
        }, */
        {
          key: 'name',
          label: this.$t('operations.table.name'),
          ...common,
          sortable: true
        },
        {
          key: 'type',
          label: this.$t('operations.table.type'),
          ...common,
          sortable: true
        },
        {
          key: 'state',
          label: this.$t('operations.table.state'),
          ...common,
          sortable: true
        },
        {
          key: 'driver',
          label: this.$t('operations.table.driver'),
          ...common,
          sortable: true
        },
        {
          key: 'vehicle',
          label: this.$t('operations.table.vehicle'),
          ...common,
          sortable: true
        },
        {
          key: 'addressName',
          label: this.$t('operations.table.address'),
          ...common,
          sortable: true
        },
        {
          key: 'scheduled',
          label: this.$t('operations.table.scheduled'),
          ...common,
          sortable: true
        },
        {
          key: 'action',
          label: this.$t('operations.table.actions'),
          ...common,
          sortable: true
        },
      ];
    },
    stateItems() {
      return this.states.map((s) => {
        return {
          ...s,
          name: this.transformIdState(s.id),
        };
      });
    },
    operationItems() {
      if (!this.operations || !Array.isArray(this.operations)) return [];

      let operationsMapped = this.operations.map((o) => {
        const addressName = o.spot.address;

        let plate = '';
        let driver = '';
        if(o.relationDone?.relRouteResource){
          plate = o.relationDone.relRouteResource.plateVehicle;
          driver = `${o.relationDone.relRouteResource.firstNameDriver} ${o.relation.relRouteResource.lastNameDriver}`;
        }else if(o.relation?.relRouteResource){
          plate = o.relation.relRouteResource.plateVehicle;
          driver = `${o.relation.relRouteResource.firstNameDriver} ${o.relation.relRouteResource.lastNameDriver}`;
        }
        return {
          ...o,
          addressName: addressName ? `${addressName.street}, ${addressName.city}, ${addressName.country.name}` : '',
          state: o.relation.idState,
          stateName: o.relation.idState ? this.transformIdState(o.relation.idState) : null,
          vehicle: plate,
          driver: driver,
          scheduled: moment(o.relationDone ? o.relationDone.startOperationDate : o.relation.startOperationDate).format('YYYY-MM-DD HH:mm [hrs.]'),
          typeName: o.type ? this.operationTypeOptions.find(item => item.type === o.type).name : null,
        };
      });

      this.operationsMap = operationsMapped;
      
      this.resetGlobalStats();
      this.operationsMap.forEach((operation) => {
        this.globalStats.totalOpsFilter++;
        this.globalStats.totalOps++;
        if (operation.state === 'DONE') {
          this.globalStats.totalOpsDoneFilter++;
          this.globalStats.totalOpsDone++;
        } else if (operation.state === 'REJECTED') {
          this.globalStats.totalOpsRejectedFilter++;
          this.globalStats.totalOpsRejected++;
        } else if (operation.state === 'NOTDONE') {
          this.globalStats.totalOpsPendingFilter++;
          this.globalStats.totalOpsPending++;
        } else if (operation.state === 'PARTIALLYDONE') {
          this.globalStats.totalOpsPartiallyFilter++;
          this.globalStats.totalOpsPartially++;
        }
      });

      return this.operationsMap;
    },
  },
  watch: {
  }
};
